<template>
  <SidebarNavItem :classes="navItemClasses">
    <a class="nav-label" :href="url">
      <AppIcon :name="icon || 'circle'" :class="iconClasses" inherit-size />
      <span>{{ name }}</span>
    </a>
  </SidebarNavItem>
</template>

<script>
import { SidebarNavItem } from '@coreui/vue'

export default {
  name: 'AppSidebarNavLabel',
  components: { SidebarNavItem },
  props: {
    name: { type: String, default: '' },
    url: { type: String, default: '#' },
    icon: { type: String, default: 'fa fa-circle' },
    classes: { type: [String, Array, Object], default: '' },
    label: { type: Object, required: true, default: () => ({}) },
  },
  computed: {
    navItemClasses() {
      return ['hidden-cn', ...this.getClassArray(this.classes)]
    },
    iconClasses() {
      return [
        'nav-icon',
        this.label.variant ? `text-${this.label.variant}` : '',
        this.label.class || '',
      ]
    },
  },
  methods: {
    getClassArray(classes) {
      if(!classes) return []
      if(typeof classes === 'string' || classes instanceof String) return classes.split(' ')
      if(Array.isArray(classes)) return classes
      return Object.keys(classes).filter(key => classes[key])
    },
  },
}
</script>
